<template>
    <div>
        <div class="d-flex align-items-center mt-2">
            {{ $t('files.select_theme_background_image') }}

            <a
                v-if="selected"
                href="#"
                class="remove-file"
                @click="$emit('remove')" v-tooltip="$t('files.delete_selected_theme_background_image')"
            >
                <icon name="times" scale="0.8"></icon>
            </a>
        </div>

        <div class="mt-2 mb-5 d-flex align-items-stretch">
            <label
                class="btn btn-secondary btn-sm btn-icon mr-2 upload-file"
                v-tooltip="$t('files.upload_own_background_help')"
            >
                {{ $t('files.upload_own_background') }}
                <input type="file" @change="selectFile" accept="image/png,image/jpeg,image/jpg,image/gif,image/heic" />
            </label>

            <div class="d-flex files-wrapper">
                <div v-for="file of files" :key="file.url" @click="$emit('select', file)">
                    <img :src="file.url" v-if="file.type === FILE_EDITOR_THEME_TYPE.IMAGE" class="mr-1" style="height: 100px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { FILE_EDITOR_THEME_TYPE } from '../enums/theme-types';
    import * as Sentry from '@sentry/vue';

    export default {
        props: {
            ceremonyCode: {
                type: String,
                required: true,
            },

            types: {
                type: Array,
                required: true,
            },

            selected: {
                type: Boolean,
                default: false,
            },

            file: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                files: [],
            };
        },

        computed: {
            FILE_EDITOR_THEME_TYPE() {
                return FILE_EDITOR_THEME_TYPE;
            },
        },

        watch: {
            types() {
                this.getThemeFiles(this.types);
            },
        },

        mounted() {
            this.getThemeFiles(this.types);
        },

        methods: {
            async getThemeFiles(types) {
                this.$emit('loading', true);

                try {
                    const response = await this.$http.get(`/api/ceremonies/code/${this.ceremonyCode}/file-editor/theme-files`, {
                        types: types.join(','),
                    });

                    this.files = response.data;
                } catch (exception) {
                    Sentry.captureException(exception);

                    this.$notify({
                        group: 'default',
                        title: this.$t('general.something_went_wrong'),
                        type: 'error',
                        duration: 2500,
                        position: 'top right',
                    });
                } finally {
                    this.$emit('loading', false);
                }
            },

            async uploadFile(file) {
                this.$emit('loading', true);

                try {
                    const data = new FormData();
                    data.append('file', file);

                    const response = await this.$http.post(`/api/ceremonies/code/${this.ceremonyCode}/file-editor/${this.file.id}/custom-theme-file`, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });

                    this.$emit('select', response.data);
                } catch (exception) {
                    Sentry.captureException(exception);

                    this.$notify({
                        group: 'default',
                        title: this.$t('general.something_went_wrong'),
                        type: 'error',
                        duration: 2500,
                        position: 'top right',
                    });
                } finally {
                    this.$emit('loading', false);
                }
            },

            selectFile(event) {
                this.uploadFile(event.target.files[0]);
            },
        },
    };

</script>

<style lang="scss" scoped>

    .files-wrapper {
        overflow: auto;
    }

    .upload-file {
        input {
            width: 0;
            height: 0;
            overflow: hidden;
            opacity: 0;
        }
    }

    .remove-file {
        margin-left: 5px;
        margin-top: -5px;
        width: 20px;
        height: 20px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        color: #718096;
        fill: #718096;
        box-shadow: 2px 3px 5px rgba(31, 45, 61, 0.2);
        z-index: 1;
    }

</style>
